// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;
 
export const BASEURL = `https://epixcinemas-api.nuviotech.co`;
 
// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://epixcinemas-api.nuviotech.co`;
 
export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const EPIX = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImIwYzQ4OWZhLWQ0ZmQtNDJiMC04M2UxLTczNTM0Y2YzZTg3ZCIsImlhdCI6MTcxMDMyMDE2NX0.rnR42n7m_cwFgnvZAHowcyLnezFfp20mOJS7ku2oC9M`

export const TOKEN = EPIX



// WEBPACK FOOTER //
// ./src/config/index.js